module.exports = __webpack_public_path__ + "img/icon-close.77ca17.svg";